import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, Http } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxMaskModule, IConfig} from 'ngx-mask';
//Import para grafiscas
import { ChartsModule } from 'ng2-charts/ng2-charts';
import {Chart} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
//Tablas Gastos
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule, MatInputModule, MatDialogModule, MatDialog } from '@angular/material';
//Test
import { HttpClientModule } from '@angular/common/http';
//Components partials
import { AppComponent } from './app.component';
import { LeftSidebarComponent } from './components/partials/left-sidebar/left-sidebar.component';
import { RightSidebarComponent } from './components/partials/right-sidebar/right-sidebar.component';
import { MobileBarComponent } from './components/partials/mobile-bar/mobile-bar.component';
import { CatalogoListaDefaultComponent } from './components/partials/catalogo-lista-default/catalogo-lista-default.component';
import { CatalogoDetallesDefaultComponent } from './components/partials/catalogo-detalles-default/catalogo-detalles-default.component';
import { PaginationComponent } from './components/partials/pagination/pagination.component';
import { CerrarSessionModalComponent } from './components/partials/cerrar-session-modal/cerrar-session-modal.component';
import { BackLinkComponent } from './components/partials/back-link/back-link.component';
import { AjaxLoadingComponent } from './components/partials/ajax-loding/ajax-loading.component';
import { NoItemsMessageComponent } from './components/partials/no-items-message/no-items-messge.component';
//components tools
import { Message1ModalComponent } from './components/tools/modals/message1-modal/message1-modal.component';
import { TouchspinComponent } from './components/tools/touchspin/touchspin.component';
import { SuccessModalComponent } from './components/tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from './components/tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from './components/tools/modals/confirm-modal/confirm-modal.component';
import { Select2SingleComponent } from './components/tools/select2/select2-single/select2-single.component';
import { SwitcherComponent } from './components/tools/switcher/switcher.component';
import { DatepickerComponent } from './components/tools/datepicker/datepicker.component';
import { WarningModalComponent } from './components/tools/modals/warning-modal/warning-modal.component';
import { Select2GroupsComponent } from './components/tools/select2/select2-groups/select2-groups.component';
import { Select2MultiComponent } from './components/tools/select2/select2-multi/select2-multi.component';
import { InputCurrencyComponent } from './components/tools/input-currency/input-currency.component';
import { InputCurrencyReadonlyComponent } from './components/tools/input-currency-readonly/input-currency-readonly.component';
import { Select2MultiGroupsComponent } from './components/tools/select2/select2-multi-groups/select2-multi-groups.component';
import { ConfirmTextModalComponent } from './components/tools/modals/confirm-text-modal/confirm-text-modal.component';
import { ProgressBarComponent } from './components/tools/progress-bar/progress-bar.component';
import { TouchspinV2Component } from './components/tools/touchspin-v2/touchspin-v2.component';
import { TexteditorComponent } from './components/tools/texteditor/texteditor.component';
//componentes site
import { LoginComponent } from './components/autenticacion/login/login.component';
import { UsuariosComponent } from './administracion/usuarios/usuarios.component';
import { UsuariosModalComponent } from './administracion/usuarios/usuarios-modal/usuarios-modal.component';
import { ConfiguracionCreditosComponent } from './administracion/configurar-creditos/configurar-creditos.component';
//Creditos
import { CreditosComponent } from './creditos/creditos.component';
import { ListadoCreditosComponent } from './creditos/listado/listado-creditos.component';
import { TablaAmortizacionComponent } from './creditos/tabla-amortizacion/tabla-amortizacion.component';
//Creditos Partials
import { FormularioClienteComponent } from './creditos/components/formulario-cliente/formulario-cliente.component';
import { FormularioAvalComponent } from './creditos/components/formulario-aval/formulario-aval.component';
import { FooterCreditoComponent } from './creditos/components/footer-credito/footer-credito.component';
import { HeaderCreditoComponent } from './creditos/components/header-credito/header-credito.component';
import { ModalFechaContratoComponent } from './creditos/components/header-credito/components/modal-fecha-contrato.component';
import { FormularioContratoComponent } from './creditos/components/formulario-contrato/formulario-contrato.component';
import { AdjuntarArchivosComponent } from './creditos/components/adjuntar-archivos/adjuntar-archivos.component';
import { HeaderAmortizacionComponent } from './creditos/components/header-amortizacion/header-amortizacion.component';
import { SimuladorClienteComponent } from './creditos/components/simulador-cliente/simulador-cliente.component';
import { FormularioPagareComponent } from './creditos/components/formulario-pagare/formulario-pagare.component';
import { FormularioPromotorComponent } from './creditos/components/formulario-promotor/formulario-promotor.component';
//Avales
import { FormularioAvaluoComponent } from './creditos/components/formulario-avaluo/formulario-avaluo.component';
import { ListadoAvalesComponent } from './creditos/components/listado-avales/listado-avales.component';
import { ArchivosAvalComponent } from './creditos/components/formulario-aval/components/archivos-aval/archivos-aval.component';
//Hipotecarios
import { CreditosHipotecarioSimulacionComponent } from './creditos/hipotecario/simulacion/creditos-hipotecario-simulacion.component';
import { HipoteacrioDetallesComponent } from './creditos/hipotecario/detalles/hipotecario-detalles.component';
import { CapacidadPagoComponent } from './creditos/hipotecario/detalles/components/capacidad-pago.component';
//Automotriz
import { AutomotrizSimuladorComponent } from './creditos/automotriz/simulador/automotriz-simulador.component';
import { AutomotrizDetallesComponent } from './creditos/automotriz/detalles/automotriz-detalles.component';
import { AutomotrizAvaluoComponent } from './creditos/automotriz/detalles/components/avaluo/automotriz-avaluo.component';
//Prendario
import { PrendarioSimuladorComponent } from './creditos/prendario/simulador/prendario-simulador.component';
import { PrendarioDetallesComponent } from './creditos/prendario/detalles/prendario-detalles.component';
//Personal
import { PersonalSimuladorComponent } from './creditos/personal/simulador/personal-simulador.component';
import { PersonalDetallesComponent } from './creditos/personal/detalles/personal-detalles.component';
//Verde
import { VerdeSimuladorComponent } from './creditos/verde/simulador/verde-simulador.component';
import { VerdeDetallesComponent } from './creditos/verde/detalles/verde-detalles.component';
import { VerdeAvaluoComponent } from './creditos/verde/detalles/components/avaluo/verde-avaluo.component';
import { VerdeCapacidadPagoComponent } from './creditos/verde/detalles/components/capacidad-pago/capacidad-pago.component';
//Carburacion
import { CarburacionSimuladorComponent } from './creditos/crediga-carburacion/simulador/carburacion-simulador.component';
import { CarburacionDetallesComponent } from './creditos/crediga-carburacion/detalles/carburacion-detalles.component';
import { CarburacionUnidadComponent } from './creditos/crediga-carburacion/detalles/components/unidad/carburacion-unidad.component';
import { CarburacionGascomComponent } from './creditos/crediga-carburacion/detalles/components/gascom/carburacion-gascom.component';
//Estacionario
import { EstacionarioSimuladorComponent } from './creditos/credigas-estacionario/simulador/estacionario-simulador.component';
import { EstacionarioDetallesComponent } from './creditos/credigas-estacionario/detalles/estacionario-detalles.component';
import { CentroConsumoComponent } from './creditos/credigas-estacionario/detalles/components/centro-consumo/centro-consumo.component';
import { EstacionarioGascomComponent } from './creditos/credigas-estacionario/detalles/components/gascom/estacionario-gascom.component';
//Nomina
import { NominaSimuladorComponent } from './creditos/nomina/simulador/nomina-simulador.component';
import { PlazoItemComponent } from './creditos/nomina/simulador/components/plazo-item/plazo-item.component';
import { NominaDetallesComponent } from './creditos/nomina/detalles/nomina-detalles.component';
import { NominaCapacidadPagoComponent } from './creditos/nomina/detalles/components/capacidad-pago/capacidad-pago.component';
//Comercialización
import { ComercialSimuladorComponent } from './creditos/comercializacion/simulador/comercial-simulador.component';
import { ComercialDetallesComponent } from './creditos/comercializacion/detalles/comercial-detalles.component';
import { MesesSubproductoComponent } from './creditos/comercializacion/detalles/components/meses-subproducto/meses-subproducto.component';
//Clientes
import { ClientesListadoComponent} from './clientes/listado/clientes-listado.component';
import { ClientesDetallesComponent } from './clientes/detalles/clientes-detalles.component';
import { ClienteDetalleComponent } from './clientes/cliente-form/detalles/cliente-detalle.component';
import { ClientesCreditosComponent } from './clientes/detalles/components/creditos/clientes-creditos.component';
import { ClienteFormComponent } from './clientes/cliente-form/cliente-form.component';
// Agrega estas importaciones en la parte superior de tu archivo
import { ClienteMoralFormComponent } from './clientes/cliente-form/component-form/cliente-moral-form.component';
import { CamposPersonaFormComponent } from './clientes/cliente-form/component-form/campos-persona-form.component';
//Convenios
import { ConveniosDetallesComponent } from './convenios/detalles/convenios-detalles.component';
import { ArchivoConvenioComponent } from './convenios/detalles/components/archivo-convenio/archivo-convenio.component';
import { ConveniosListadoComponent } from './convenios/listado/convenios-listado.component';
import { ConveniosPagosMultiplesComponent } from './convenios/pagos-multiples/convenios-pagos-multiples.component';
import { ModalConfirmacionPagosComponent } from './convenios/pagos-multiples/components/modal-confirmacion-pagos/modal-confirmacion-pagos.component';
//Pagos
import { TablaPagosComponent } from './creditos/components/tabla-pagos/tabla-pagos.component';
import { AgregarPagoComponent } from './creditos/components/tabla-pagos/components/agregar-pago/agregar-pago.component';
import { PagosDistribucionComponent } from './creditos/components/pagos-distribucion/pagos-distribucion.component';
import { AgregarPagoDistComponent } from './creditos/components/pagos-distribucion/components/agregar-pago/agregar-pago-dist.component';
//Reportes
import { ReportesListadoComponent } from './reportes/listado/reportes-listado.component';
//Reportes Concentrados
import { ReporteConcentradosComponent } from './reportes/concentrados/reporte-concentrados.component';
import { CreditosColocadosComponent } from './reportes/concentrados/components/creditos-colocados/creditos-colocados.component';
import { ConcentradosPagosComponent } from './reportes/concentrados/components/concentrados-pagos/concentrados-pagos.component';
//Reportes Colocados
import { ReporteColocadosComponent } from './reportes/creditos-colocados/reporte-colocados.component';
import { ColocadosFiltrosComponent } from './reportes/creditos-colocados/components/filtros/colocados-filtros.component';
import { ColocadosFooterComponent } from './reportes/creditos-colocados/components/footer/colocados-footer.component';
import { ColocadosGeneralComponent } from './reportes/creditos-colocados/components/reporte-general/colocados-general.component';
import { ColocadosHipotecariosComponent } from './reportes/creditos-colocados/components/hipotecarios/colocados-hipotecarios.component';
import { ColocadosAutomotricesComponent } from './reportes/creditos-colocados/components/automotrices/colocados-automotrices.component';
import { ColocadosPrendariosComponent } from './reportes/creditos-colocados/components/prendarios/colocados-prendarios.component';
import { ColocadosVerdesComponent } from './reportes/creditos-colocados/components/verdes/colocados-verdes.component';
import { ColocadosPersonalesComponent } from './reportes/creditos-colocados/components/personales/colocados-personales.component';
import { ColocadosNominasComponent } from './reportes/creditos-colocados/components/nominas/colocados-nominas.component';
import { ColocadosCarburacionesComponent } from './reportes/creditos-colocados/components/carburaciones/colocados-carburaciones.component';
import { ColocadosEstacionariosComponent } from './reportes/creditos-colocados/components/estacionarios/colocados-estacionarios.component';
//Reportes Pagos
import { ReportePagosComponent } from './reportes/pagos/reporte-pagos.component';
import { ReporteAvancesPagosComponent } from './reportes/pagos/avances/reporte-avances-pagos.component';
import { ReportePagosPenalizacionesComponent } from './reportes/pagos/penalizaciones/reporte-pagos-penalizaciones.component';
//Reportes Cartera
import { CarteraGeneralComponent } from './reportes/cartera/general/cartera-general.component';
import { CarteraCreditosComponent } from './reportes/cartera/creditos/cartera-creditos.component';
//Reportes Cobranza
import { ReporteCobranzaNominaComponent } from './reportes/cobranza/nomina/reporte-cobranza-nomina.component';
import { ReporteCobranzaGeneralComponent } from './reportes/cobranza/general/reporte-cobranza-general.component';
//Reportes Clientes
import { ReporteClientesGeneralComponent } from './reportes/clientes/general/reporte-clientes-general.component';
//Reportes Clientes
import { ReporteConveniosGeneralComponent } from './reportes/convenios/general/reporte-convenios-general.component';
//Reportes Promotores
import { ReportePromotoresGeneralComponent } from './reportes/promotores/general/reporte-promotores-general.component';
//Promotores
import { PromotoresListadoComponent } from './promotores/listado/promotores-listado.component';
import { ModalPromotorComponent } from './promotores/listado/components/modal-promotor/modal-promotor.component';
//Routing
import {routing,appRoutingProviders} from './app.routing';
//services tools
import { Globals } from './services/tools/Globals.service';
import { ErrorsService } from './services/tools/errors.service';
import { ModulesService } from './services/tools/modules.service';
import { HelpersService } from './services/tools/helpers.service';
import { ValidatorService } from './services/tools/validator.service';
import { ReportsHelperService } from './services/tools/reports-helpers.service';
import { DatesHelpersService } from './services/tools/dates-helpers.service';
//Cookies
import { CookieService } from 'ngx-cookie-service';
//Services
import { GeneralServices } from './services/general.services';
import { ConstantsService } from './services/constants.service';
import { AutenticacionGuard } from './services/autenticacion.guard';
import { AutenticacionService } from './services/autenticacion.service';
import { UsuariosService } from './services/usuarios.service';
import { SucursalesService } from './services/sucursales.service';
import { ConfiguracionCreditosService } from './services/configuracion-creditos.service';
import { ClientesService } from './services/clientes.service';
import { PrestamosService } from './services/prestamos.service';
import { PlazosService } from './services/plazos.service';
import { CreditosService } from './services/creditos.service';
import { AvaluosService } from './services/avaluos.service';
import { AvalesService } from './services/avales.service';
import { ContratosService } from './services/contratos.service';
import { ConveniosService } from './services/convenios.service';
import { ArchivosConveniosService } from './services/archivos-convenios.service';
import { CentroConsumoService } from './services/creditos/centro-consumo.service';
import { ArchivosCreditosService } from './services/archivos-creditos.service';
import { CarburacionesUnidadesService } from './services/creditos/carburaciones-unidades.service';
import { GascomService } from './services/creditos/gascom.service';
import { PagosService } from './services/pagos.service';
import { ArchivosPagosService } from './services/archivos-pagos.service';
import { PagaresService } from './services/pagares.service';
import { ArchivosAvalesService } from './services/archivos-avales.service';
import { PromotoresService } from './services/promotores.service';
import { PaisService } from './services/pais.services';
import { CpService } from './services/cp.service';

//Creditos Services
import { CreditosHipotecariosService } from './services/creditos-hipotecarios.service';
import { AutomotricesService } from './services/creditos/automotrices.service';
import { PrendariosService } from './services/creditos/prendarios.service';
import { PersonalesService } from './services/creditos/personales.service';
import { VerdesService } from './services/creditos/verdes.service';
import { CarburacionesService } from './services/creditos/carburaciones.service';
import { EstacionariosService } from './services/creditos/estacionarios.service';
import { NominasService } from './services/creditos/nominas.service';
import { ComercializacionService } from './services/creditos/comercializacion.service';
//Reportes Services
import { ReportesConcentradosService } from './services/reportes/reportes-concentrados.service';
import { ReportesColocadosService } from './services/reportes/reportes-colocados.service';
import { ReportesPagosService } from './services/reportes/reportes-pagos.service';
import { ReportesCarteraService } from './services/reportes/reportes-cartera.service';
import { ReportesCobranzaService } from './services/reportes/reportes-cobranzas.service';
import { ReportesfService } from './services/fondeadores-reportes/reportesf.service';
import { ReportesClientesService } from './services/reportes/reportes-clientes.service';
import { ReportesConveniosService } from './services/reportes/reportes-convenios.service';
import { ReportesPromotoresService } from './services/reportes/reportes-promotores.service';
import { SucursalesComponent } from './administracion/sucursales/sucursales.component';
import { SucursalesModalComponent } from './administracion/sucursales/sucursales-modal/sucursales-modal.component';
import { RolGuard } from './services/rol.guard';
import { CategoriasGastosComponent } from './administracion/categorias-gastos/categorias-gastos.component';
import { CategoriasGastosModalComponent } from './administracion/categorias-gastos/categorias-gastos-modal/categorias-gastos-modal.component';
import { CategoriasGastosService } from './services/categorias-gastos.service';
import { CategoriaGastoTarjetaComponent } from './administracion/categorias-gastos/categoria-gasto-tarjeta/categoria-gasto-tarjeta.component';
import { SubcategoriasGastosComponent } from './administracion/categorias-gastos/subcategorias-gastos/subcategorias-gastos.component';
import { SubcategoriasGastosService } from './services/subcategorias-gastos.service';
import { SubcategoriasGastosModalComponent } from './administracion/categorias-gastos/subcategorias-gastos-modal/subcategorias-gastos-modal.component';
import { GastosComponent } from './gastos/gastos.component';
import { GastosService } from './services/gastos.service';
import { GastosModalComponent } from './gastos/gastos-modal/gastos-modal.component';
import { GastosDetalladosComponent } from './gastos/gastos-detallados/gastos-detallados.component';
import { GastosCategoriaComponent } from './gastos/gastos-categoria/gastos-categoria.component';
import { GastosSubcategoriaComponent } from './gastos/gastos-subcategoria/gastos-subcategoria.component';
import { GastosDetalladosMesComponent } from './gastos/gastos-detallados-mes/gastos-detallados-mes.component';
//Fondeadores
import { FondeadoresComponent } from './administracion/fondeadores/fondeadores.component';
import { RegistroFondeadorComponent } from './administracion/fondeadores/registro-fondeador/registro-fondeador.component';
import { FondeadoresService } from './services/fondeadores.service';
import { BeneficiariosService } from './services/beneficiarios.service';
import { DeleteGastoComponent } from './gastos/dialogs/delete-gasto/delete-gasto.component';
import { UpdateGastoComponent } from './gastos/dialogs/update-gasto/update-gasto.component';
import { ProductosFinancierosComponent } from './administracion/productos-financieros/productos-financieros.component';
import { ProductosFinancierosService } from './services/productos-financieros.service';
import { RegistrarProductoFinancieroComponent } from './administracion/productos-financieros/registrar-producto-financiero/registrar-producto-financiero.component';
import { EliminarProductoFinancieroComponent } from './administracion/productos-financieros/eliminar-producto-financiero/eliminar-producto-financiero.component';
import { EsquemaInversionModalComponent } from './administracion/fondeadores/esquema-inversion-modal/esquema-inversion-modal.component';
import { EsquemaInversionService } from './services/esquema-inversion.service';
import { EliminarFondeadorComponent } from './administracion/fondeadores/eliminar-fondeador/eliminar-fondeador.component';
import { SimulacionEsquemaInversionComponent } from './administracion/fondeadores/simulacion-esquema-inversion/simulacion-esquema-inversion.component';
import { PerfilFondeadorComponent } from './administracion/fondeadores/perfil-fondeador/perfil-fondeador.component';
import { SimulacionModalComponent } from './administracion/fondeadores/simulacion-esquema-inversion/simulacion-modal/simulacion-modal.component';
import { GastosDetalladosCategoriaComponent } from './gastos/gastos-detallados-categoria/gastos-detallados-categoria.component';
import { EmpresasComponent } from './administracion/empresas/empresas.component';
import { RegistrarEmpresaModalComponent } from './administracion/empresas/registrar-empresa-modal/registrar-empresa-modal.component';
import { EmpresasService } from './services/empresas.service';
import { EliminarEmpresaModalComponent } from './administracion/empresas/eliminar-empresa-modal/eliminar-empresa-modal.component';
import {MatRadioModule} from '@angular/material/radio';
import { DetallesInversionComponent } from './administracion/fondeadores/detalles-inversion/detalles-inversion.component';
import { IncrementarInversionModalComponent } from './administracion/fondeadores/detalles-inversion/incrementar-inversion-modal/incrementar-inversion-modal.component';
import { DevolucionesInversionModalComponent } from './administracion/fondeadores/detalles-inversion/devoluciones-inversion-modal/devoluciones-inversion-modal.component';
import { SimulacionEsquemaAhorradorComponent } from './administracion/fondeadores/simulacion-esquema-ahorrador/simulacion-esquema-ahorrador.component';
import { PagosInversionModalComponent } from './administracion/fondeadores/detalles-inversion/pagos-inversion-modal/pagos-inversion-modal.component';
import { PagosFondeadoresService } from './services/pagos-fondeadores.service';
import { ModuloVistaComponent } from './modulo-vista/modulo-vista.component';
import { RegistroSocioFondeadorComponent } from './modulo-vista/registro-socio-fondeador/registro-socio-fondeador.component';
import { SocioFondeadorService } from './services/socio-fondeador.service';
import { AumentarSaldoModalComponent } from './modulo-vista/aumentar-saldo-modal/aumentar-saldo-modal.component';
import { RetirarSaldoModalComponent } from './modulo-vista/retirar-saldo-modal/retirar-saldo-modal.component';
import { PerfilSocioFondeadorComponent } from './modulo-vista/perfil-socio-fondeador/perfil-socio-fondeador.component';
import { AceptarRetiroModalComponent } from './components/tools/modals/aceptar-retiro-modal/aceptar-retiro-modal.component';
import { RechazarRetiroModalComponent } from './components/tools/modals/rechazar-retiro-modal/rechazar-retiro-modal.component';
import { EliminarPagoModalComponent } from './administracion/fondeadores/detalles-inversion/pagos-inversion-modal/eliminar-pago-modal/eliminar-pago-modal.component';
import { EliminarRetiroModalComponent } from './administracion/fondeadores/detalles-inversion/devoluciones-inversion-modal/eliminar-retiro-modal/eliminar-retiro-modal.component';
import { EliminarEsquemaModalComponent } from './administracion/fondeadores/detalles-inversion/eliminar-esquema-modal/eliminar-esquema-modal.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ReporteriaComponent } from './administracion/fondeadores/reporteria/reporteria.component';
import { FondeosComponent } from './administracion/fondeadores/reporteria/fondeos/fondeos.component';
import { RendimientosPagadosComponent } from './administracion/fondeadores/reporteria/rendimientos-pagados/rendimientos-pagados.component'; 
import { RendimientosAPagarComponent } from './administracion/fondeadores/reporteria/rendimientos-a-pagar/rendimientos-a-pagar.component';
import { DevolucionesFondeoComponent } from './administracion/fondeadores/reporteria/devoluciones-fondeo/devoluciones-fondeo.component';
import { SaldoFondeadoresComponent } from './administracion/fondeadores/reporteria/saldo-fondeadores/saldo-fondeadores.component';
import { EditarConvenioCreditComponent } from './components/tools/modals/editar-convenio-credit/editar-convenio-credit.component';
///// dashboard
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './services/dashboard.service';
import { KpiCardComponent } from './dashboard/kpi-card.component';
/////inversionistas
import { InversionistasComponent } from './inversiones/inversionistas.component';
import { InversionistaDetallesComponent } from './inversiones/detalles/inversionista-detalles.component';
import { InversionistasServiceold } from './services/inversionistas.service-old';
import { InversionistasService } from './services/inversionistas.service';
import { InversionesService } from './services/inversiones.service';
///// pagares
import { PagaresComponent } from './inversiones/pagares/pagares.component';
import { CrearPagareComponent } from './inversiones/pagares/crear/crear-pagare.component';
import { PagareDetallesComponent } from './inversiones/pagares/detalles/pagare-detalles.component';
import { CalendarioPagosComponent } from './inversiones/pagares/calendario/calendario-pagos.component';

//export const options: Partial<IConfig> | (() => Partial<IConfig>);
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [
    //components
    AppComponent,
    //partials
    LeftSidebarComponent,
    RightSidebarComponent,
    MobileBarComponent,
    CatalogoListaDefaultComponent,
    CatalogoDetallesDefaultComponent,
    PaginationComponent,
    CerrarSessionModalComponent,
    BackLinkComponent,
    AjaxLoadingComponent,
    //tools
    Message1ModalComponent,
    TouchspinComponent,
    SuccessModalComponent,
    ErrorModalComponent,
    ConfirmModalComponent,
    Select2SingleComponent,
    SwitcherComponent,
    DatepickerComponent,
    WarningModalComponent,
    Select2GroupsComponent,
    Select2MultiComponent,
    InputCurrencyComponent,
    InputCurrencyReadonlyComponent,
    Select2MultiGroupsComponent,
    ConfirmTextModalComponent,
    ProgressBarComponent,
    TouchspinV2Component,
    TexteditorComponent,
    //site
    LoginComponent,
    UsuariosComponent,
    UsuariosModalComponent,
    ConfiguracionCreditosComponent,
    CreditosComponent,
    CreditosHipotecarioSimulacionComponent,
    ListadoCreditosComponent,
    HipoteacrioDetallesComponent,
    AutomotrizSimuladorComponent,
    TablaAmortizacionComponent,
    AutomotrizDetallesComponent,
    AutomotrizAvaluoComponent,
    PrendarioSimuladorComponent,
    PrendarioDetallesComponent,
    PersonalSimuladorComponent,
    PersonalDetallesComponent,
    VerdeSimuladorComponent,
    VerdeDetallesComponent,
    VerdeCapacidadPagoComponent,
    CarburacionSimuladorComponent,
    CarburacionDetallesComponent,
    EstacionarioSimuladorComponent,
    EstacionarioDetallesComponent,
    NominaSimuladorComponent,
    NominaDetallesComponent,
    ComercialSimuladorComponent,
    ComercialDetallesComponent,
    MesesSubproductoComponent,
    //PartialCreditos
    FormularioClienteComponent,
    FormularioAvaluoComponent,
    FooterCreditoComponent,
    HeaderCreditoComponent,
    ModalFechaContratoComponent,
    FormularioContratoComponent,
    AdjuntarArchivosComponent,
    HeaderAmortizacionComponent,
    VerdeAvaluoComponent,
    CarburacionUnidadComponent,
    CarburacionGascomComponent,
    CentroConsumoComponent,
    EstacionarioGascomComponent,
    SimuladorClienteComponent,
    NominaCapacidadPagoComponent,
    FormularioPagareComponent,
    PlazoItemComponent,
    //Avales
    FormularioAvalComponent,
    ListadoAvalesComponent,
    ArchivosAvalComponent,
    //Pagos
    TablaPagosComponent,
    AgregarPagoComponent,
    PagosDistribucionComponent,
    AgregarPagoDistComponent,
    //Partial Hipotecarios
    CapacidadPagoComponent,
    //Clientes
    ClientesListadoComponent,
    ClientesDetallesComponent,
    ClientesCreditosComponent,
    ClienteDetalleComponent,
    ClienteMoralFormComponent,
    CamposPersonaFormComponent,
    
    //Convenios
    ConveniosDetallesComponent,
    ArchivoConvenioComponent,
    ConveniosListadoComponent,
    ConveniosPagosMultiplesComponent,
    ModalConfirmacionPagosComponent,
    //Promotores
    PromotoresListadoComponent,
    ModalPromotorComponent,
    //Reportes
    ReportesListadoComponent,
    ReporteConcentradosComponent,
    ReporteColocadosComponent,
    ReportePagosComponent,
    ReporteAvancesPagosComponent,
    ReporteCobranzaNominaComponent,
    ReporteCobranzaGeneralComponent,
    ReporteClientesGeneralComponent,
    ReporteConveniosGeneralComponent,
    ReportePagosPenalizacionesComponent,
    ReportePromotoresGeneralComponent,
    //Otros
    CreditosColocadosComponent,
    ConcentradosPagosComponent,
    ColocadosFiltrosComponent,
    ColocadosFooterComponent,
    ColocadosGeneralComponent,
    ColocadosHipotecariosComponent,
    ColocadosAutomotricesComponent,
    ColocadosPrendariosComponent,
    ColocadosVerdesComponent,
    ColocadosPersonalesComponent,
    CarteraGeneralComponent,
    ColocadosNominasComponent,
    ColocadosCarburacionesComponent,
    ColocadosEstacionariosComponent,
    CarteraCreditosComponent,
    NoItemsMessageComponent,
    FormularioPromotorComponent,
    SucursalesComponent,
    SucursalesModalComponent,
    CategoriasGastosComponent,
    CategoriasGastosModalComponent,
    CategoriaGastoTarjetaComponent,
    SubcategoriasGastosComponent,
    SubcategoriasGastosModalComponent,
    GastosComponent,
    GastosModalComponent,
    GastosDetalladosComponent,
    GastosCategoriaComponent,
    GastosSubcategoriaComponent,
    GastosDetalladosMesComponent,
    FondeadoresComponent,
    RegistroFondeadorComponent,
    DeleteGastoComponent,
    UpdateGastoComponent,
    ProductosFinancierosComponent,
    RegistrarProductoFinancieroComponent,
    EliminarProductoFinancieroComponent,
    EsquemaInversionModalComponent,
    EliminarFondeadorComponent,
    SimulacionEsquemaInversionComponent,
    PerfilFondeadorComponent,
    SimulacionModalComponent,
    GastosDetalladosCategoriaComponent,
    EmpresasComponent,
    RegistrarEmpresaModalComponent,
    EliminarEmpresaModalComponent,
    DetallesInversionComponent,
    IncrementarInversionModalComponent,
    DevolucionesInversionModalComponent,
    SimulacionEsquemaAhorradorComponent,
    PagosInversionModalComponent,
    ModuloVistaComponent,
    RegistroSocioFondeadorComponent,
    AumentarSaldoModalComponent,
    RetirarSaldoModalComponent,
    PerfilSocioFondeadorComponent,
    AceptarRetiroModalComponent,
    RechazarRetiroModalComponent,
    EliminarPagoModalComponent,
    EliminarRetiroModalComponent,
    EliminarEsquemaModalComponent,
    ReporteriaComponent,
    FondeosComponent,
    RendimientosPagadosComponent,
    RendimientosAPagarComponent,
    DevolucionesFondeoComponent,
    SaldoFondeadoresComponent,
    EditarConvenioCreditComponent,
    ClienteFormComponent,
    //Dashboard
    DashboardComponent,
    KpiCardComponent,
    //Inversionistas
    InversionistasComponent,
    InversionistaDetallesComponent,
    PagaresComponent,
    CrearPagareComponent,
    PagareDetallesComponent,
    CalendarioPagosComponent
  ],
  imports: [
    HttpModule,
    BrowserModule,
    routing,
    NgbModule.forRoot(),
    FormsModule,
    NgxMaskModule.forRoot(options),
    HttpClientModule,
    ChartsModule,
    MatTableModule,
    MatPaginatorModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatRadioModule,
    MatTabsModule
  ],
  entryComponents: [
    FormularioAvalComponent,
    DeleteGastoComponent,
    UpdateGastoComponent,
    RegistrarProductoFinancieroComponent,
    EliminarProductoFinancieroComponent,
    EsquemaInversionModalComponent,
    EliminarFondeadorComponent,
    SimulacionModalComponent,
    RegistrarEmpresaModalComponent,
    EliminarEmpresaModalComponent,
    IncrementarInversionModalComponent,
    DevolucionesInversionModalComponent,
    PagosInversionModalComponent,
    AumentarSaldoModalComponent,
    RetirarSaldoModalComponent,
    AceptarRetiroModalComponent,
    RechazarRetiroModalComponent,
    EliminarPagoModalComponent,
    EliminarRetiroModalComponent,
    EliminarEsquemaModalComponent,
    EditarConvenioCreditComponent,
  ],
  providers: [
    appRoutingProviders,
    //tools
    Globals,
    ErrorsService,
    ModulesService,
    HelpersService,
    ValidatorService,
    CookieService,
    ReportsHelperService,
    //services
    GeneralServices,
    ConstantsService,
    AutenticacionService,
    AutenticacionGuard,
    UsuariosService,
    SucursalesService,
    ConfiguracionCreditosService,
    CreditosHipotecariosService,
    CategoriasGastosService,
    ClientesService,
    PrestamosService,
    PlazosService,
    CreditosService,
    AvaluosService,
    AvalesService,
    ContratosService,
    ArchivosCreditosService,
    AutomotricesService,
    PrendariosService,
    PersonalesService,
    VerdesService,
    CarburacionesService,
    CarburacionesUnidadesService,
    GascomService,
    EstacionariosService,
    CentroConsumoService,
    ConveniosService,
    ArchivosConveniosService,
    NominasService,
    PagosService,
    ArchivosPagosService,
    ReportesConcentradosService,
    ReportesColocadosService,
    ReportesPagosService,
    ReportesCarteraService,
    PagaresService,
    ArchivosAvalesService,
    ComercializacionService,
    ReportesCobranzaService,
    ReportesfService,
    PromotoresService,
    DatesHelpersService,
    ReportesClientesService,
    ReportesConveniosService,
    ReportesPromotoresService,
    SubcategoriasGastosService,
    GastosService,
    RolGuard,
    FondeadoresService,
    BeneficiariosService,
    MatDialog,
    ProductosFinancierosService,
    EsquemaInversionService,
    EmpresasService,
    PagosFondeadoresService,
    SocioFondeadorService,
    PaisService,
    CpService,
    DashboardService,
    InversionistasServiceold,
    InversionistasService,
    InversionesService,
    PagaresService,
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts